export default "__VITE_ASSET__BQ0l1l7B__"